import { render } from "./MessageHeaderSection.vue?vue&type=template&id=62ac3d71"
import script from "./MessageHeaderSection.vue?vue&type=script&lang=js"
export * from "./MessageHeaderSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__